// New unified enums that match backend
export enum FeedbackRating {
  Negative = -1,
  Neutral = 0,
  Positive = 1
}

export enum FeedbackCategory {
  General = 0,
  Bug = 1,
  Feature = 2,
  UserExperience = 3,
  Performance = 4,
  Content = 5,
  Other = 99
}

// Legacy types for backwards compatibility
export type LegacyFeedbackRating = 'positive' | 'neutral' | 'negative';
export type LegacyFeedbackCategory = 
  | 'accuracy' 
  | 'clarity'
  | 'relevance'
  | 'usefulness'
  | 'bug'
  | 'suggestion'
  | 'other';

// New unified feedback submission interface that matches backend DTO
export interface FeedbackSubmission {
  category: FeedbackCategory;
  rating: FeedbackRating;
  itemName: string;
  comments?: string;
  pageUrl: string;
  interactionId?: string;
  questionId?: string;
  transcriptId?: string;
  evaluationId?: string;
  serverVersion?: string;
  serverBuildTime?: string;
  metadata?: Record<string, unknown>;
  diagnostic?: Record<string, unknown>;
}

// Legacy interface for backwards compatibility
export interface FeedbackStandardFields {
  category: LegacyFeedbackCategory;
  rating: LegacyFeedbackRating;
  itemName: string;
  notes?: string;
  pageUrl: string;
  interactionId?: string;
  questionId?: string;
  transcriptId?: string;
  evaluationId?: string;
  diagnostic?: DiagnosticInfo;
  serverVersion?: string;
  serverBuildTime?: string;
}

export interface DiagnosticInfo {
  userAgent?: string;
  language?: string;
  platform?: string;
  viewportWidth?: number;
  viewportHeight?: number;
  devicePixelRatio?: number;
  timeZone?: string;
  screenWidth?: number;
  screenHeight?: number;
  screenColorDepth?: number;
  pageLoadTime?: number;
  domReadyTime?: number;
  networkType?: string;
  networkDownlink?: number;
  networkRtt?: number;
  totalJSHeapSize?: number;
  usedJSHeapSize?: number;
}

// Additional context that will be moved to metadata
export interface FeedbackContext extends Record<string, unknown> {
  itemName: string;
  interactionId?: string;
  questionId?: string;
  transcriptId?: string;
  evaluationId?: string;
  reason?: string;
  [key: string]: unknown;
}

export interface FeedbackData extends FeedbackStandardFields {
  metadata?: Record<string, unknown>;
}

export interface FeedbackState {
  isOpen: boolean;
  context: FeedbackContext | null;
}
